import { ModesDocumentVerificationAfterSigning } from "../store/api/types/applicationApiTypes";

export const verificationModesAfterSign: Record<
  string,
  ModesDocumentVerificationAfterSigning | undefined
> = {
  re_signing_first_stage: ModesDocumentVerificationAfterSigning["resigning"],
  signing: ModesDocumentVerificationAfterSigning["standart_signing"],
  signature_required: ModesDocumentVerificationAfterSigning["standart_signing"],
};
